export default {
  init() {
    $(document).foundation();

    $(".slider").slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      centerMode: false,
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    $(".slider-home").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      //centerMode: true,
      dots: true,
      arrows: false,
      autoplay: true,
      // autoplaySpeed: 3500,
      cssEase: "linear",
      speed: 3000,
    });

    $(".item").matchHeight();

    $(".wpcf7-form input")
      .on("focus", function () {
        $(this).parent().parent().addClass("active");
      })
      .on("focusout", function () {
        if (!$(this).val()) {
          $(this).parent().parent().removeClass("active");
        }
      });

    $(window).load(function () {
      $(".grid").masonry({
        itemSelector: ".columns",
      });
    });

    moment.locale("fr");

    const clndr = {};
    const currentMonth = moment().format("YYYY-MMMM");
    const nextMonth = moment().add(1, "month").format("YYYY-MMMM");
    const events = [];
    const windowEvents = Object.keys(window._event);

    for (let index = 0; index < window._event.length; index++) {
      const element = window._event[index];

      for (let index2 = 0; index2 < element['dates'].length; index2++) {
        const date = element['dates'][index2];

        events.push({
          date: moment(date).format("YYYY-MM-DD"),
          title: element.title,
          url: element.link,
        });
      }
    }

    $("#mini-clndr").clndr({
      moment: moment,
      weekOffset: 0,
      //daysOfTheWeek: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      numberOfRows: 5,
      template: $("#mini-clndr-template").html(),
      events: events,
      clickEvents: {
        click: function (target) {
          if (target.events.length) {
            let date = target.events[0].date;
            window.location = "/?date=" + date;
          }
        },
      },
      adjacentDaysChangeMonth: true,
      forceSixRows: true,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js